'use strict'

/**
 * Composes the detail view of a device
 *
 */
var Marionette = require('marionette')
var App = require('app')
var _ = require('lodash')
var PageModel = require('src/common/page-model')

/* Views */
var View = require('./view.js')

var DeviceShow = function (options) {
  var Controller = Marionette.Object.extend({
    initialize: function (options) {
      var self = this

      var device = options.device
      var id = options.id

      device || (device = App.globalChannel.request('device:entity', id))

      self.device = device

 
      // Tabs
      var tabs = [
        { label: 'Status', slug: 'status', elementId: 'tab-status', roles: [] },
        { label: 'Situation', slug: 'situation', elementId: 'tab-situation', roles: [] },
        { label: 'Events', slug: 'events', elementId: 'tab-events', roles: [] },
      ]
      var scheduleTab = { label: 'Schedule', slug: 'schedule', elementId: 'tab-schedule', roles: [] };

      var pageModel = new PageModel({
        title: '',
        buttons: [
          { label: 'control', icon: true, primary: true, slug: 'control', action: 'device:control', roles: ['super', 'admin'] },
          { label: 'edit', icon: true, slug: 'edit', action: 'device:edit', roles: ['super', 'admin'] }
        ],
        tabs: tabs
      })
      

      // wait till the device is loaded, after load
      // check if the schedules tab needs to be set.

      // these device types do not support schedules
      var typesWithoutSchedule = ['rtm_rhm', 'rtm_rhm_mqtt'];
      
      var setScheduleTab = function() {
        if (typesWithoutSchedule.indexOf(device.get('type')) > -1) return;
        tabs.push({ label: 'Schedule', slug: 'schedule', elementId: 'tab-schedule', roles: [] })
        pageModel.set('tabs', tabs)
      }

      if (device.get('type')) {
        setScheduleTab();
      } else {
        self.listenTo(device, 'change', function () {
          setScheduleTab();
        })
      }


      self.layout = self.getLayoutView(pageModel, device)

      self.listenTo(self.layout, 'render', function () {
        self.headerDetailsRegion(device)
      })

      self.listenTo(self.layout, 'tab:switch', self.onTabSwitch)
      self.listenTo(self.layout, 'device:edit', self.showDeviceEdit)
      self.listenTo(self.layout, 'device:control', self.showDeviceControl)

      // listen for realtime changes
      let throttledOnDeviceUpdate = _.debounce(_.bind(self.onRemoteDeviceUpdated, self), 1000, { 'trailing': true })
      App.globalChannel.on('devices:event:updated', throttledOnDeviceUpdate)

      App.rootLayout.showChildView('mainRegion', self.layout)
    },


    showDeviceControl: function (args) {
      App.globalChannel.trigger('device:control', {region: App.rootLayout.getRegion('dialogRegion'), device: args.model})
    },
    showDeviceEdit: function (args) {
      App.globalChannel.trigger('device:edit', {region: App.rootLayout.getRegion('dialogRegion'), device: args.model})
    },
    /* Event methods --------------------------------------------------------- */
    onTabSwitch: function (tab) {
      var self = this

      switch (tab.slug) {
        case 'status':
          App.globalChannel.trigger('device-status:show', {region: self.layout.getRegion('bodyRegion'), device: self.device})
          break
        case 'situation':
          App.globalChannel.trigger('device-situation:show', {region: self.layout.getRegion('bodyRegion'), device: self.device})
          break
        case 'events':
          App.globalChannel.trigger('device-events:show', {region: self.layout.getRegion('bodyRegion'), device: self.device})
          break
        case 'schedule':
          App.globalChannel.trigger('schedule:list', {region: self.layout.getRegion('bodyRegion'), device: self.device})
          break
      }
    },
    onRemoteDeviceUpdated: function (data) {
      if (data._id !== this.device.id) return
      console.log(data)
      // fetch the model and update
      if (!this.device) return false
       this.device.set(data)
    },
    /* Regions --------------------------------------------------------------- */
    headerDetailsRegion: function (device) {
      var headerDetailView = this.getHeaderDetailView(device)
      this.layout.showChildView('headerDetailsRegion', headerDetailView)
    },
    /* Views ----------------------------------------------------------------- */
    getHeaderDetailView: function (model) {
      return new View.HeaderDetails({model: model})
    },
    getLayoutView: function (pageModel, model) {
      return new View.Layout({pageModel: pageModel, model: model})
    }
  })

  return new Controller(options)
}

module.exports = DeviceShow



// WEBPACK FOOTER //
// ./js/modules/devices/show/index.js